module.exports = __webpack_public_path__ + "img/ico-my-loc.9db71395.svg";